import {ValueObject} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'

export class ContactConfiguratorNotLoggedSellerRequest extends ValueObject {
  #dealerId
  #specsId
  #color
  #buyer

  constructor({dealerId, specsId, color, buyer}) {
    super()
    this.#dealerId = dealerId
    this.#specsId = specsId
    this.#color = color
    this.#buyer = buyer
  }

  static validate({dealerId, specsId, buyer}) {
    if (!dealerId)
      throw InvalidParamsSharedError.create(
        '[ContactConfiguratorNotLoggedSellerRequest.validate] param dealerId is required'
      )
    if (!specsId)
      throw InvalidParamsSharedError.create(
        '[ContactConfiguratorNotLoggedSellerRequest.validate] param specsId is required'
      )

    // Validate buyer if provided
    if (buyer) {
      if (!buyer.name)
        throw InvalidParamsSharedError.create(
          '[ContactConfiguratorNotLoggedSellerRequest.validate] buyer.name is required when buyer is provided'
        )
      if (!buyer.mail)
        throw InvalidParamsSharedError.create(
          '[ContactConfiguratorNotLoggedSellerRequest.validate] buyer.mail is required when buyer is provided'
        )
    }
  }

  static create({dealerId, specsId, color, buyer}) {
    ContactConfiguratorNotLoggedSellerRequest.validate({dealerId, specsId, buyer})
    return new ContactConfiguratorNotLoggedSellerRequest({dealerId, specsId, color, buyer})
  }

  get dealerId() {
    return this.#dealerId
  }

  get specsId() {
    return this.#specsId
  }

  get color() {
    return this.#color
  }

  get buyer() {
    return this.#buyer
  }

  get value() {
    return {
      dealerId: this.#dealerId,
      specsId: this.#specsId,
      color: this.#color,
      buyer: this.#buyer
    }
  }

  getBody() {
    const body = {
      dealerId: this.#dealerId,
      subjectData: {
        specsId: this.#specsId,
        color: this.#color
      }
    }

    if (this.#buyer) {
      body.buyer = this.#buyer
    }

    return body
  }
}
